module.exports = require("js-file-download");


//////////////////
// WEBPACK FOOTER
// external "js-file-download"
// module id = 578
// module chunks = 0